"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var Progress = /** @class */ (function (_super) {
    tslib_1.__extends(Progress, _super);
    function Progress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Progress.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'progress';
        _super.prototype.createLayers.call(this, layerProps);
    };
    Progress.prototype.update = function (value, style) {
        var layer = this.layers[0];
        layer.update(value, style);
    };
    Progress.getDefaultOptions = layer_1.default.getDefaultOptions;
    return Progress;
}(plot_1.default));
exports.default = Progress;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/sparkline/progress/index.js
// module id = 1006
// module chunks = 37